/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRadar = createReactComponent("outline", "radar", "IconRadar", [["path", { "d": "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9", "key": "svg-0" }], ["path", { "d": "M16 9a5 5 0 1 0 -7 7", "key": "svg-1" }], ["path", { "d": "M20.486 9a9 9 0 1 0 -11.482 11.495", "key": "svg-2" }]]);

export { IconRadar as default };
//# sourceMappingURL=IconRadar.mjs.map
